import React from 'react';
import { Search, X } from 'lucide-react';
import {
  BugReportFilters as Filters,
  CategoriaBugReport,
  Criticidade,
  BugStatus,
  Origem,
} from '../../services/bugReportService';

interface Props {
  filters: Filters;
  categorias: CategoriaBugReport[];
  onChange: (filters: Filters) => void;
  onReset: () => void;
}

const CRITICIDADES: Criticidade[] = ['BAIXA', 'MEDIA', 'ALTA', 'CRITICA'];
const STATUSES: BugStatus[] = ['ABERTO', 'EM_ANALISE', 'EM_CORRECAO', 'CORRIGIDO', 'FECHADO', 'NAO_REPRODUZIVEL'];
const ORIGENS: Origem[] = ['OFFLINE', 'ONLINE'];

export const BugReportFilters: React.FC<Props> = ({ filters, categorias, onChange, onReset }) => {
  const updateFilter = (key: keyof Filters, value: any) => {
    onChange({ ...filters, [key]: value === '' ? undefined : value, page: 1 });
  };

  const hasActiveFilters =
    filters.criticidade || filters.status || filters.categoria_id || filters.origem || filters.search;

  return (
    <div className="bg-white p-4 rounded-lg border border-gray-200 mb-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
        {/* Busca */}
        <div className="lg:col-span-2">
          <label className="block text-xs font-semibold text-gray-600 mb-1">Buscar</label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              className="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Titulo ou descricao..."
              value={filters.search || ''}
              onChange={(e) => updateFilter('search', e.target.value)}
            />
          </div>
        </div>

        {/* Criticidade */}
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">Criticidade</label>
          <select
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
            value={filters.criticidade || ''}
            onChange={(e) => updateFilter('criticidade', e.target.value as Criticidade)}
          >
            <option value="">Todas</option>
            {CRITICIDADES.map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </div>

        {/* Status */}
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">Status</label>
          <select
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
            value={filters.status || ''}
            onChange={(e) => updateFilter('status', e.target.value as BugStatus)}
          >
            <option value="">Todos</option>
            {STATUSES.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>

        {/* Categoria */}
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">Categoria</label>
          <select
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
            value={filters.categoria_id || ''}
            onChange={(e) => updateFilter('categoria_id', e.target.value ? Number(e.target.value) : undefined)}
          >
            <option value="">Todas</option>
            {categorias.filter((c) => c.ativo).map((c) => (
              <option key={c.id} value={c.id}>{c.nome}</option>
            ))}
          </select>
        </div>

        {/* Origem */}
        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1">Origem</label>
          <select
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
            value={filters.origem || ''}
            onChange={(e) => updateFilter('origem', e.target.value as Origem)}
          >
            <option value="">Todas</option>
            {ORIGENS.map((o) => (
              <option key={o} value={o}>{o}</option>
            ))}
          </select>
        </div>

        {hasActiveFilters && (
          <div className="flex items-end">
            <button
              type="button"
              onClick={onReset}
              className="flex items-center gap-1 px-3 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded"
            >
              <X className="w-4 h-4" /> Limpar filtros
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
